import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

const FormError = ({errorInfo, onSubmit}) => {
  return (
    <div className='lf'>
      <h3 className='c-r'>Při autentizaci došlo k chybě:</h3>
      <p className='lf-pa c-2'>{errorInfo.code}</p>
      <p className='lf-pa c-2'>{errorInfo.message}</p>
      <button className='lf-b mb-2' onClick={onSubmit}>OK</button>
    </div>
  )
}

FormError.propTypes = {
  errorInfo: PropTypes.object,
  onSubmit: PropTypes.func
}

export default FormError



// WEBPACK FOOTER //
// ./src/components/UserForms/FormError.js